import styled from 'styled-components';

import { container } from 'shared/constants/mixins';

export default styled.div`
  ${container}
`;
